import { useEffect, useState } from 'react';
import { supabase } from '../lib/supabase';

export interface DestinationPort {
  id: number;
  name: string;
  country: string | null;
}

export const useDestinationPorts = () => {
  const [destinationPorts, setDestinationPorts] = useState<DestinationPort[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchDestinationPorts = async () => {
      try {
        const { data, error } = await supabase
          .from('booking_destination_port')
          .select('*')
          .order('name');

        if (error) throw error;
        setDestinationPorts(data || []);
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Failed to fetch destination ports');
        console.error('Error fetching destination ports:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchDestinationPorts();
  }, []);

  return { destinationPorts, loading, error };
}; 